import React, { Component } from 'react';
import clsx from 'clsx';
import { Table, withStyles } from "@material-ui/core";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import TableHeader from "./tableHeader";
import TableFooter from './tableFooter';
import TableBody from './tableBody';
import { getScrollbarWidth } from '../../../../../common/utilities/utilitiesFunctions';
import $ from 'jquery'

const styles = theme => ({
	iconButton: {
		paddingRight: 5,
		fontSize: 22
	},
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
		marginBottom: '-13px'
	},
	green: {
		color: 'green',
	},
	red: {
		color: 'red',
	},
	darkorange: {
		color: 'darkorange',
	},
	margin: {
		width: '100%',
		minWidth: '80px'
	},
	tableCell: {
		padding: '4px',
	},
	tableWrapper: {
		overflow: 'scroll',
		position: 'fixed',
		bottom: 0,
		zIndex: '1',
	},
	tableFixed: {
		width: '100%',
		margin: 'auto',
		borderCollapse: 'separate',
		borderSpacing: '0'
	},
	gotSkills: {
		color: 'orange'
	},
	isOT: {
		color: 'red'
	},
	isNotOT: {
		color: 'black'
	},
	rootToolbar: {
		display: 'flex',
		margin: '0px -39px',
		border: '1px solid #e8eff5',
		backgroundColor: 'white',
	},
	highlight:
		theme.palette.type === 'light'
			? {
				color: theme.palette.secondary.main,
				backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			}
			: {
				color: theme.palette.text.primary,
				backgroundColor: theme.palette.secondary.dark,
			},
	spacer: {
		flex: '1 1 100%',
	},
	actions: {
		color: theme.palette.text.secondary,
	},
	title: {
		flex: '0 0 auto',
	},
	search: {
		position: 'relative',
		borderRadius: theme.shape.borderRadius,
		backgroundColor: 'rgba(204, 204, 204, 0.15)',
		'&:hover': {
			backgroundColor: 'rgba(204, 204, 204, 0.10)',
		},
		marginLeft: 0,
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing.unit * 3,
			width: 'auto',
		},
	},
	searchIcon: {
		width: theme.spacing.unit * 9,
		height: '100%',
		position: 'absolute',
		pointerEvents: 'dense',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	inputRoot: {
		color: 'inherit',
		width: '100%',
	},
	inputInput: {
		paddingTop: theme.spacing.unit,
		paddingRight: theme.spacing.unit,
		paddingBottom: theme.spacing.unit,
		paddingLeft: theme.spacing.unit * 10,
		transition: theme.transitions.create('width'),
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: 200,
		}
	},
	input: {
		height: '36px',
		textAlign: 'right'
	},
	noMaxWidth: {
		maxWidth: 'none',
	},
	button: {
		margin: theme.spacing.unit,
	},
	buttonStatus: {
		borderRadius: '20px',
		margin: theme.spacing.unit,
		minWidth: '120px'
	},
	rollout: {
		float: 'right',
		display: 'flex'
	},
	header: {
		display: 'inline-flex',
		marginTop: '20px',
		marginBottom: '10px',
		padding: '0 0 5px 0px',
		width: '100%',
	},
	flexButtonStatus: {
		flex: 1,
		marginLeft: '30px',
		maxWidth: '120px'
	},
	flexWrapper: {
		flex: 1
	},
	headerTwo: {
		display: 'inline-flex',
		marginBottom: '15px',
		padding: '0 0 5px 0px',
		width: '100%',
	},
	headerItem: {
		minWidth: 120,
		display: 'grid',
		margin: '0 5px'
	},
	alignFont: {
		display: 'flex'
	},
	effectiveDate: {
		marginRight: '8%',
		padding: '5px 0px 5px 0px',
	},
	Typo: {
		padding: '5px 0px 5px 0px',
	},
	pausedStatus: {
		borderColor: 'darkorange',
		color: 'darkorange'
	},
	stopStatus: {
		borderColor: 'red',
		color: 'red'
	},
	activeStatus: {
		borderColor: 'green',
		color: 'green'
	},
	regularStatus: {
		borderColor: 'rgba(0, 0, 0, 0.26)',
		color: 'black'
	},
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
		padding: '0px 110px 5px 0px'
	},
	dense: {
		marginTop: 16,
	},
	groupTextField: {
		border: '1px solid #a5a5a5',
		borderRadius: '4px',
		padding: '0px 5px 10px 5px',
		display: 'grid'
	},
	notes: {
		minHeight: '100px',
		width: "100%",
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
	},
	ButtonAction: {
		margin: '5px',
		borderColor: '#1a518a',
		'&:disabled': {
			border: 0
		}
	},
	labelButton: {
		textTransform: 'capitalize'
	},
	disabledIcon: {
		color: '#b9b9b9'
	},
	labelHeader: {
		color: '#bfbfbf',
		fontWeight: 100,
	},
	infoHeader: {
		fontWeight: 500
	},
	CloseOpen: {
		marginTop: 65
	},
	OpenClose: {
		marginTop: -65
	},
});

class CustomTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			navbarMARGIN: { close: 0, open: 65, heightC: 65, heightO: -65 },
			navbar: false,
		}
	}

	marginHandler = () => {
		// this.state.navbar ? this.handleToolbar(this.state.navbarMARGIN.close, this.state.navbarMARGIN.heightC) : this.handleToolbar(this.state.navbarMARGIN.open, this.state.navbarMARGIN.heightO);
		// this.setState({ navbar: !this.state.navbar }, () => {
		// 	// if (this.state.navbar) {
		// 	// 	this.handleToolbar(this.state.navbarMARGIN.open, this.state.navbarMARGIN.heightO)
		// 	// } else {
		// 	// 	this.handleToolbar(this.state.navbarMARGIN.close, this.state.navbarMARGIN.heightC)
		// 	// }
		// 	this.handleTable();
		// })
		this.setState({ navbar: !this.state.navbar }, () => {
			if (this.state.navbar) {
				this.handleToolbar(this.state.navbarMARGIN.open, this.state.navbarMARGIN.heightO)
			}
			else {
				this.handleToolbar(this.state.navbarMARGIN.close, this.state.navbarMARGIN.heightC)
			}
		})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleTable)
		document.getElementById('navBarMenu').removeEventListener('click', this.marginHandler);
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleTable);
		document.getElementById('navBarMenu').addEventListener('click', this.marginHandler);
	}

	getNavBarStatus = () => {
		return document.getElementById('navBarMenu').attributes.navbarstatus.value === 'open' ? { close: -65, open: 65, heightC: 65, heightO: -65 } : { close: -65, open: 65, heightC: 65, heightO: -65 }
	}

	componentDidUpdate() {
		if ($('#WrapperTable .dataview-column') !== null) {
			this.handleTable();
		}
		
		// this.handleTable();
		// if (!this.state.navbar) {
		// 	// this.handleTable();	
		// } else {
		// 	if (this.props.showRight) {
		// 		this.setRightTable();
		// 	}
		// }
		// if (this.state.navbar) {
		// 	this.setState({
		// 		'navbar': false,
		// 		// navbarMARGIN: this.getNavBarStatus(),
		// 	});
		// }
	}

	setRightTable = () => {
		let axuTable = document.getElementById('WrapperTableCOLLEFT');
		let axuTable2 = document.getElementById('WrapperTableCOLRIGHT');
		axuTable2.style.marginTop = axuTable.style.marginTop;
		axuTable2.style.height = axuTable.style.height;
		axuTable2.style.top = axuTable.style.top;
		axuTable2.style.right = 0;
		axuTable2.style.overflowX = 'hidden';
		axuTable2.style.transition = axuTable.style.transition;
	}

	handleToolbar = (marginTop = 0, height = 0) => {
		let axuTableMAIN = document.getElementById('WrapperTable');
		let calcHeight = height + axuTableMAIN.getBoundingClientRect().height - getScrollbarWidth();
		axuTableMAIN.style.marginTop = marginTop + 'px';
		let axuTable = document.getElementById('WrapperTableCOLLEFT');
		axuTable.style.height = calcHeight + 'px';
		axuTable.style.marginTop = marginTop + 'px';
		// if (document.getElementById('WrapperTableCOLRIGHT')) {
		// 	let axuTable2 = document.getElementById('WrapperTableCOLRIGHT');
		// 	axuTable2.style.height = calcHeight + 'px';
		// 	axuTable2.style.marginTop = marginTop + 'px';
		// }
	}

	handleTable = () => {
		let axuTableMAIN = document.getElementById('WrapperTable');
		let topMain = document.getElementsByClassName('tableToolbar')[0].getBoundingClientRect();
		let topMainCalc = topMain.top + topMain.height;
		axuTableMAIN.style.width = '100%';
		axuTableMAIN.style.top = topMainCalc + 'px';
		axuTableMAIN.style.left = '0px';
		axuTableMAIN.style.overflow = 'scroll';
		axuTableMAIN.style.transition = 'margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms';
		let dataviewColumns = $('#WrapperTable .dataview-column')
		let maxWidth = 0
		for (let col of dataviewColumns) {
			maxWidth += col.getBoundingClientRect().width
		}
		let axuTable = document.getElementById('WrapperTableCOLLEFT');
		let calcHeight = axuTableMAIN.getBoundingClientRect().height - getScrollbarWidth();
		if (window.innerWidth <= maxWidth) {
			axuTable.style.display = 'none'
		} else {
			axuTable.style.display = 'block'
			axuTable.style.width = maxWidth + 'px';
			axuTable.style.height = calcHeight + 'px';
			axuTable.style.top = topMainCalc + 'px';
			axuTable.style.left = '0px';
			axuTable.style.overflow = 'hidden';
			axuTable.style.transition = 'margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms';
			let axuTableMainRows = $('#WrapperTable table tbody tr')
			let axuTableRows = $('#WrapperTableCOLLEFT table tbody tr')
			for (let i = 0; i < axuTableMainRows.length; i++) {
				let colHeight = axuTableMainRows[i].getBoundingClientRect().height
				let row = axuTableRows[i].children
				for (let cell of row) {
					$(cell).css({
						height: colHeight,
					})
				}
			}
		}

		// let maxWidthRight = getScrollbarWidth();
		// let list = document.getElementsByClassName('fixedRight');
		// for (let item of list) {
		// 	maxWidthRight += item.getBoundingClientRect().width;
		// }

		if (document.getElementById('WrapperTableCOLRIGHT')) {
			let axuTable2 = document.getElementById('WrapperTableCOLRIGHT');
			axuTable2.style.height = calcHeight + 'px';
			axuTable2.style.width = '0px';  //maxWidthRight + 'px';
			axuTable2.style.top = topMainCalc + 'px';
			axuTable2.style.right = '0px';
			axuTable2.style.overflowX = 'hidden';
			axuTable2.style.transition = 'margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms';
		}
	}

	linkScroll = (ORI, TARG1, TARG2, showRight) => {
		if (showRight && (ORI === 'WrapperTableCOLLEFT' || ORI === 'WrapperTable')) {
			if (document.getElementById(ORI).scrollTop !== document.getElementById(TARG1).scrollTop
				&& document.getElementById(ORI).scrollTop !== document.getElementById(TARG2).scrollTop) {

				document.getElementById(TARG1).scrollTop = document.getElementById(ORI).scrollTop;
				document.getElementById(TARG2).scrollTop = document.getElementById(ORI).scrollTop;
			} else if (document.getElementById(TARG1).scrollTop !== document.getElementById(ORI).scrollTop
				&& document.getElementById(TARG1).scrollTop !== document.getElementById(TARG2).scrollTop) {

				document.getElementById(ORI).scrollTop = document.getElementById(TARG1).scrollTop;
				document.getElementById(TARG2).scrollTop = document.getElementById(TARG1).scrollTop;
			} else if (document.getElementById(TARG2).scrollTop !== document.getElementById(ORI).scrollTop
				&& document.getElementById(TARG2).scrollTop !== document.getElementById(TARG1).scrollTop
				&& document.getElementById(ORI).scrollTop !== document.getElementById(TARG1).scrollTop) {

				document.getElementById(TARG1).scrollTop = document.getElementById(TARG2).scrollTop;
				document.getElementById(ORI).scrollTop = document.getElementById(TARG2).scrollTop;
			}
		}
	}

	render() {
		const { classes, footerRows = [], bodyRows = [], dataviewColumnsHeader = [], variableColumnsHeader = [], nbVisilbleDataviewCols, showFooter = true, showRight = false } = this.props;
		return (
			<React.Fragment>
				<div id='WrapperTable'
					onScroll={() => this.linkScroll('WrapperTable', 'WrapperTableCOLLEFT', 'WrapperTableCOLRIGHT', showRight)}
					className={classes.tableWrapper}>
					<Table id='Table' className={classes.tableFixed} aria-labelledby="tableTitle">
						<TableHeader
							variableColumnsHeader={variableColumnsHeader}
							dataviewColumnsHeader={dataviewColumnsHeader}
							fixed={false}
							showRight={showRight}
						/>
						<TableBody
							dataviewColumnsHeader={dataviewColumnsHeader}
							rows={bodyRows}
							showRight={showRight}
							fixed={false}
						/>
						{
							showFooter ?
								<TableFooter
									nbColDataview={nbVisilbleDataviewCols}
									// daysWeeks={daysWeeks}
									contentData={footerRows}
									fixed={false}
								/> : ''
						}

					</Table>
				</div>
				<div id='WrapperTableCOLLEFT'
					// style={{ display: 'none' }} 
					onScroll={() => this.linkScroll('WrapperTableCOLLEFT', 'WrapperTable', 'WrapperTableCOLRIGHT')}
					className={clsx(classes.tableWrapper, 'sideTable')}>
					<Table id='TableCOLLEFT' className={classes.tableFixed} aria-labelledby="tableTitle">
						<TableHeader
							variableColumnsHeader={variableColumnsHeader}
							dataviewColumnsHeader={dataviewColumnsHeader}
							fixed={true}
							position={'left'}
						/>
						<TableBody
							dataviewColumnsHeader={dataviewColumnsHeader}
							showRight={showRight}
							rows={bodyRows}
							fixed={true}
							position={'left'}
						/>
						{
							showFooter ?
								<TableFooter
									nbColDataview={nbVisilbleDataviewCols}
									showRight={showRight}
									contentData={footerRows}
									fixed={true}
									position={'left'}
								/> : ''
						}

					</Table>
				</div>
				<div id='WrapperTableCOLRIGHT'
					// style={{ display: 'none' }} 
					onScroll={() => this.linkScroll('WrapperTableCOLRIGHT', 'WrapperTableCOLLEFT', 'WrapperTable')}
					className={clsx(classes.tableWrapper, 'sideTable', classes.sideTable)}>
					<Table id='Table' className={classes.tableFixed} aria-labelledby="tableTitle">
						<TableHeader
							variableColumnsHeader={variableColumnsHeader}
							dataviewColumnsHeader={dataviewColumnsHeader}
							fixed={true}
							showRight={showRight}
						/>
						<TableBody
							dataviewColumnsHeader={dataviewColumnsHeader}
							showRight={showRight}
							rows={bodyRows}
							submitActionRollout={this.submitActionRollout}
							fixed={true}
						/>
						{/* <TableFooter
                nbColDataview={nbVisilbleDataviewCols}
                daysWeeks={daysWeeks}
                coverages={coverages}
                fixed={true}
              /> */}
					</Table>
				</div>
			</React.Fragment>
		);
	}
}

export default withStyles(styles)(CustomTable);